import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-evaluacion-inicial-caso',
  templateUrl: './evaluacion-inicial-caso.component.html',
  styleUrls: ['./evaluacion-inicial-caso.component.scss'],
})
export class EvaluacionInicialCasoComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      accion_autorizada: [
        values ? values.accion_autorizada : false,
        [Validators.required],
      ],
      descripcion: [values ? values.descripcion : ''],
      nombre: [values ? values.nombre : ''],
      cargo: [values ? values.cargo : ''],
      NM: [values ? values.NM : ''],
      // correo: [values ? values.correo : '', [Validators.required, Validators.email, Validators.max(30)]],
    });
    this.changeIsInvolved(values ? values.accion_autorizada : '');
  }

  changeIsInvolved(value) {
    if (value == 'No') {
      this.form.controls.descripcion.setValidators([Validators.required]);
      this.form.controls.nombre.setValidators([Validators.required]);
      this.form.controls.cargo.setValidators([Validators.required]);
      this.form.controls.NM.setValidators([Validators.required]);
    } else {
      this.form.controls.descripcion.setValidators([]);
      this.form.controls.nombre.setValidators([]);
      this.form.controls.cargo.setValidators([]);
      this.form.controls.NM.setValidators([]);
    }
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }

  OnInit(): void {}
}
